// src/CalenderCard.js
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './calender.css';

const CalenderCard = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const { t, i18n } = useTranslation();

    const isLeapYear = (year) => {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 100 === 0 && year % 400 === 0);
    };

    const getFebDays = (year) => {
        return isLeapYear(year) ? 29 : 28;
    };

    const generateCalendar = (month, year) => {
        const daysOfMonth = [
            31, getFebDays(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31
        ];

        const firstDay = new Date(year, month, 1).getDay();
        const totalDays = daysOfMonth[month];

        const calendar = [];
        let day = 1;

        // Fill in blank days before the first day of the month
        for (let i = 0; i < firstDay; i++) {
            calendar.push('');
        }

        // Fill in days of the month
        for (let i = 0; i < totalDays; i++) {
            calendar.push(day++);
        }

        return calendar;
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentDate(new Date());
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const renderCalendar = () => {
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();
        const currentDay = currentDate.getDate();
        const calendar = generateCalendar(currentMonth, currentYear);

        return (
            <div className="dashboard-calendar-days">
                {calendar.map((day, index) => (
                    <div key={index} className={`dashboard-calendar-day ${day === currentDay ? 'dashboard-today' : ''}`}>
                        {day}
                    </div>
                ))}
            </div>
        );
    };

    const monthNames = [
        t('months.january'), t('months.february'), t('months.march'), t('months.april'),
        t('months.may'), t('months.june'), t('months.july'), t('months.august'),
        t('months.september'), t('months.october'), t('months.november'), t('months.december')
    ];

    const weekDays = [
        t('weekdays.sunday'), t('weekdays.monday'), t('weekdays.tuesday'),
        t('weekdays.wednesday'), t('weekdays.thursday'), t('weekdays.friday'),
        t('weekdays.saturday')
    ];

    return (
        <div className="dashboard-calendar">
            <div className="dashboard-calendar-header">
                <span className="dashboard-month-picker" id="month-picker">{monthNames[currentDate.getMonth()]}</span>
                <div className="dashboard-year-picker" id="year-picker">
                    <span id="year">{currentDate.getFullYear()}</span>
                </div>
            </div>
            <div className="dashboard-calendar-body">
                <div className="dashboard-calendar-week-days">
                    {weekDays.map((day, index) => (
                        <div key={index}>{day}</div>
                    ))}
                </div>
                {renderCalendar()}
            </div>
            <div className="dashboard-date-time-formate">
                <div className="dashboard-day-text-formate">{t('dashboard_calendar_today')}</div>
                <div className="dashboard-date-time-value">
                    <div className="dashboard-time-formate">{currentDate.toLocaleTimeString()}</div>
                    <div className="dashboard-date-formate">{currentDate.toLocaleDateString()}</div>
                </div>
            </div>
        </div>
    );
};

export default CalenderCard;
